module.exports = __webpack_public_path__ + "static/media/6.6d305b6c.png";